<!-- Hero -->
<div class="grid grid-cols-1 lg:grid-cols-2 text-gray-800 dark:text-gray-200">
  <div class="p-6 text-center lg:text-left flex items-center justify-center">
    <section>
      <span class="block text-6xl font-bold mb-1">Gate Automation Systems</span>
      <p class="mt-0 mb-4 text-gray-700 dark:text-gray-300 leading-relaxed">
        Turnpikes manufacture a range of swing and sliding automatic gates.
      </p>
      <a
        aria-label="Contact Us"
        class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded shadow-md hover:shadow-lg transition-all duration-200"
        fragment="contact"
        label="Contact Us"
        pButton
        pRipple
        routerLink="/"></a>
      <button aria-label="Login" class="ml-3" label="Login" pButton pRipple routerLink="/login" type="button"></button>
    </section>
  </div>
  <div class="overflow-hidden hidden lg:block">
    <img
      alt="Image"
      class="lg:ml-auto block lg:h-full"
      height="600"
      ngSrc="images/landing.png"
      priority
      style="clip-path: polygon(8% 0, 100% 0%, 100% 100%, 0 100%)"
      width="800" />
  </div>
</div>

<!-- Pricing -->
<section class="bg-surface-50 dark:bg-surface-900 px-6 py-16 md:py-24" id="pricing">
  <app-pricing />
</section>

<!-- Contact -->
<section class="bg-white dark:bg-neutral-900 px-6 py-16 md:py-24" id="contact">
  <app-contact />
</section>
